<template>
  <p>independet work</p>
</template>

<script>
// TODO: add link to решу егэ
export default {
  name: "TutorialIndependetWork"
};
</script>

<style scoped></style>
